import { useIntl } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import noop from 'lib/function/noop'
import SearchExperience from 'tripPlanner/components/TripModal/TripItems/Search/SearchExperience'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

type Props = {
  tripId: string
  sectionId: string
  onClick?: () => void
}

function ExperienceSearchModalCTA({
  tripId,
  sectionId,
  onClick = noop,
}: Props) {
  const intl = useIntl()
  const openModal = useOpenModal()

  return (
    <TextButton
      kind="primary"
      startIcon={<LineSearchIcon />}
      onClick={() => {
        onClick()
        openModal(SearchExperience, { tripId, sectionId })
      }}
    >
      {intl.formatMessage({
        id: 'XNqEI8ENqxIzSzLgUOai',
        defaultMessage: 'Search experiences',
        description: 'Button to open experience search modal in trip planner',
      })}
    </TextButton>
  )
}

export default ExperienceSearchModalCTA
